/**
 * ============================== ACESSO ABERTO =============================
 *
 * Qualquer pessoa autenticada entra no produto. A lista permanece no modelo
 * somente como historico das inscricoes anteriores ao lancamento.
 * ========================================================================
 */
export const EMAILS_PERMITIDOS = [];
export const ACESSO_ABERTO = EMAILS_PERMITIDOS.length === 0;
export function emailPermitido(email) {
    if (ACESSO_ABERTO)
        return true;
    if (!email)
        return false;
    return EMAILS_PERMITIDOS.includes(email.trim().toLowerCase());
}
/** Mesma decisao usada pelas Functions e documentada nas regras do Firestore. */
export function acessoProdutoPermitido(email, claimAcessoProduto) {
    return emailPermitido(email) || claimAcessoProduto === true;
}
export const MENSAGEM_ACESSO_NEGADO = "Não foi possível abrir sua conta. Tente entrar novamente.";
export const PRIMEIRA_POSICAO_LISTA_ESPERA = 1913;
export function proximaPosicaoListaEspera(ultima) {
    const numero = Number(ultima);
    return Number.isInteger(numero) && numero >= PRIMEIRA_POSICAO_LISTA_ESPERA - 1
        ? numero + 1
        : PRIMEIRA_POSICAO_LISTA_ESPERA;
}
//# sourceMappingURL=acesso.js.map